export var defaultFilteredDomains = [
    'https://smetrics.ally.com',
    'https://assets.adobedtm.com',
    '/celebrus-api',
];
export var defaultExcludedMimeTypes = ['application/pdf'];
/**
 * List of request/response payload field names that should
 * be considered private and either blocked or masked when
 * sending to third-party tooling, analytics, etc.
 *
 * This list doesn't contain exact matches to every key name
 * used throughout the app, so instead it should be used to
 * perform a fuzzy-search against the request/response payload
 * key names.
 */
export var defaultPrivateFields = [
    'accountId',
    'accountNickname',
    'AccountNumber',
    'acctId',
    'acctNum',
    'address',
    'addressLine',
    'addrLine',
    'age',
    'answer',
    'beneficiaryAccountNumber',
    'beneficiaryName',
    'birthDate',
    'birthDt',
    'checkNumber',
    'city',
    'comment',
    'contactphoneNum',
    'country',
    'countryOfCitizenship',
    'currState',
    'customerId',
    'dateOfBirth',
    'deliveryMethodValue',
    'deviceTokenCookie',
    'disputeDesc',
    'disputeReason',
    'dob',
    'email',
    'employer',
    'extAcct',
    'first',
    'firstname',
    'fromAccountNumber',
    'fullName',
    'hint',
    'homeAddress',
    'intermediaryAccountNumber',
    'intermediaryBeneficiaryName',
    'intermediaryComments',
    'issuedIdent',
    'last',
    'lastname',
    'line1',
    'maidenName',
    'middle',
    'middleInitial',
    'middleName',
    'name',
    'newTelebankingPIN',
    'otp',
    'owner',
    'ownerNames',
    'password',
    'payeeName',
    'phone',
    'phoneNumber',
    'postAddr',
    'postalCode',
    'prefix',
    'pronoun',
    'pswd',
    'PvtBlock',
    'PvtEncrypt',
    'question',
    'questionAnswers',
    'recipientName',
    'RoutingNumber',
    'secret',
    'sms',
    'ssn',
    'ssnHash',
    'state',
    'street1',
    'street2',
    'suffix',
    'taxId',
    'taxIdentificationNumber',
    'tin',
    'token',
    'trustName',
    'userId',
    'userName',
    'vin',
    'wireComments',
    'zip',
];
export var defaultPrivateHeaders = ['Authorization'];
export var defaultConfigs = {
    filterDomains: defaultFilteredDomains,
    ignoredDomains: [],
    whitelistedFields: [],
    excludedMimeTypes: defaultExcludedMimeTypes,
    privateFieldsFuzzy: defaultPrivateFields,
    privateHeaders: defaultPrivateHeaders,
};
//# sourceMappingURL=defaults.js.map